<template>
  <div class="message_design text-center">
    <span> Signing out please wait... </span>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "userSignout",
  methods: {
    ...mapActions([
      "ssoSignout",
    ]),
    ...mapMutations([
      "setAuthUser",
    ])
  },
  created() {
    this.setAuthUser(null);
    this.$store.state.emailValid = null;
    this.$store.state.VerifyEmailResponse = null;
    this.$store.state.user = null;
    this.$store.state.abandonmentStatus = null;
    this.$store.state.ofacValid = null;
    this.$store.state.userOrgResponse = null;
    this.$store.state.organizationList = null;
    this.$store.state.domainsByOrganization = null;
    this.$store.state.docusignAccessToken = null;
    this.$store.state.docusignUserInfo = null;
    this.$store.state.pageState = null;
    this.$store.state.authcode = null;
    this.$store.state.Auth.userRole = 'anonymous';

    let tokenValidFrom = this.$store.state.tokenStartTime;
    if (tokenValidFrom) {
      let diff = new Date().getTime() - tokenValidFrom;
      let expired = diff > 600000 ? true : false;
      if (expired) {
        this.$store.state.userToken = null;
        this.$router.push("/");
      } else {
        this.ssoSignout();
      }
    } else {
      this.$store.state.userToken = null;
      this.$router.push("/");
    }
  },
};
</script>
<style scoped>
.message_design {
  background-color: #0f8575;
  color: white;
  padding: 10px;
  margin: 10px 0;
}
</style>